import {Box, Center, Flex, Image, SimpleGrid, Text} from '@chakra-ui/react'
import LightIcon from '@assets/svgs/exam/light-bulb.svg'
import AzIcon from '@assets/svgs/exam/az.svg'
import BookIcon from '@assets/svgs/exam/book.svg'
import MicIcon from '@assets/svgs/exam/mic.svg'
import {getBadgeByScore, getColorByScore} from './utilsExamResult'
import {useSelector} from 'react-redux'

const Suggest = () => {
  const {dataExamResult} = useSelector((state: any) => state.examResult)
  const dataSuggest = [
    {
      title: 'Trôi chảy',
      icon: LightIcon,
      data: dataExamResult?.suggestions.fluency,
      score: dataExamResult?.statistics.fluency,
    },
    {
      title: 'Từ vựng',
      icon: AzIcon,
      data: dataExamResult?.suggestions.vocabulary,
      score: dataExamResult?.statistics.vocabulary,
    },
    {
      title: 'Ngữ pháp',
      icon: BookIcon,
      data: dataExamResult?.suggestions.grammar,
      score: dataExamResult?.statistics.grammar,
    },
    {
      title: 'Phát âm',
      icon: MicIcon,
      data: dataExamResult?.suggestions.pronunciation,
      score: dataExamResult?.statistics.pronunciation,
    },
  ]

  return (
    <Flex flexDirection={'column'} mt={{base: '16px', md: '32px'}} gap={'16px'}>
      <Text fontSize={{base: '20px', md: '30px'}} fontWeight={700}>
        {`Gợi ý để đạt Band ${dataExamResult?.upgrade_score}`}
      </Text>
      <SimpleGrid spacing={'16px'} columns={{base: 1, md: 2, xl: 4}}>
        {dataSuggest?.map((item: any, index: any) => (
          <Box
            key={index}
            bg={'white'}
            p={{base: '16px', md: '24px'}}
            borderRadius={'16px'}>
            <Flex gap={'12px'} alignItems={'center'}>
              <Center position={'relative'}>
                <Image src={getBadgeByScore(item.score)} w={'48px'} />
                <Image
                  src={item.icon}
                  w={'16px'}
                  position={'absolute'}
                  top={'50%'}
                  left={'50%'}
                  transform={'translate(-50%, -50%)'}
                />
              </Center>
              <Text
                fontSize={'20px'}
                fontWeight={700}
                color={getColorByScore(item.score)}>
                {item.title}
              </Text>
            </Flex>
            <Flex
              flexDirection={'column'}
              border={'1px solid #F0F0F0'}
              borderRadius={'10px'}
              mt={{base: '16px', md: '32px'}}>
              {item?.data && item?.data.length > 0 ? (
                item?.data?.map((suggest: any, index: any) => (
                  <Text
                    key={index}
                    p={'16px'}
                    fontSize={'16px'}
                    fontWeight={600}
                    borderTop={index !== 0 ? '1px solid #F0F0F0' : 'unset'}>
                    {suggest}
                  </Text>
                ))
              ) : (
                <Text p={'16px'} fontSize={'16px'} fontWeight={600}>
                  {`Bạn đã đạt Band ${item.score}. Hãy duy trì phong độ và cải thiện các tiêu chí khác.`}
                </Text>
              )}
            </Flex>
          </Box>
        ))}
      </SimpleGrid>
    </Flex>
  )
}

export default Suggest
